import { render } from "./IconMoveTo.vue?vue&type=template&id=ffb5afca"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconMoveTo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ffb5afca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ffb5afca', __exports__)) {
    api.reload('ffb5afca', __exports__)
  }
  
  module.hot.accept("./IconMoveTo.vue?vue&type=template&id=ffb5afca", () => {
    api.rerender('ffb5afca', render)
  })

}


export default __exports__